import { defineComponent as _defineComponent } from 'vue'
import { HeadingDisplay, BaseText } from '@warrenbrasil/nebraska-web';

import { RLPPageData } from '@/modules/trade/services/rlp';

interface Props {
  pageData: RLPPageData;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'About',
  props: {
    pageData: null
  },
  setup(__props: any) {



return { __sfc: true,HeadingDisplay, BaseText }
}

})